import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "relative h-full -mx-2"
};
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" test notification ");
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" skip to end of season ");
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import { Season } from "@/modules/season/entity";
import { app } from "@/di";
import { EventEmitter } from "@/modules/base/events";
import { AfterDayEvaluationEvent } from "@/modules/season/events/AfterDayEvaluationEvent";
import { AfterSeasonEvaluationEvent } from "@/modules/season/events/AfterSeasonEvaluationEvent";
import SimpleActionSheet from "@/modules/vue/components/SimpleActionSheet.vue";
import SimpleActionSheetItem from "@/modules/vue/components/SimpleActionSheetItem.vue";
import MonthlyCalendar from "@/modules/vue/components/MonthlyCalendar.vue";
import LastNotification from "@/modules/notifications/components/LastNotification.vue";
import { Player, Team } from "@/modules/team/entity";
import { TransferOfferNotification } from "@/modules/transfer-market/entity/TransferOfferNotification";
import { Notifier } from "@/modules/notifications/services/Notifier";
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  async setup(__props) {
    let __temp, __restore;
    const team = ref(([__temp, __restore] = _withAsyncContext(() => Team.current()), __temp = await __temp, __restore(), __temp));
    const season = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      season.value = await Season.current();
    })), __temp = await __temp, __restore(), __temp);
    onUnmounted(app.get(EventEmitter).onOff([AfterDayEvaluationEvent, AfterSeasonEvaluationEvent], refresh));
    const skipMonth = async () => {
      season.value.currentDate = season.value.currentDate.add(1, 'month').utc();
      await season.value.save();
      await refresh();
      await app.get(EventEmitter).emitAsync(new AfterDayEvaluationEvent(season.value));
    };
    const skipToEndOfSeason = async () => {
      season.value.currentDate = season.value.endDate.subtract(3, 'day').utc();
      await season.value.save();
      await refresh();
      await app.get(EventEmitter).emitAsync(new AfterDayEvaluationEvent(season.value));
    };
    const createNotification = async () => {
      let season = await Season.current();
      const player = await Player.createQueryBuilder('player').orderBy('RANDOM()').getOneOrFail();
      const notification = new TransferOfferNotification().setPayload(player);
      notification.createdAt = season.currentDate.toDate();
      await app.get(Notifier).notify(notification);
    };
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(DefaultInGameLayout, null, _createSlots({
        default: _withCtx(() => [_createVNode(LastNotification, {
          class: "w-full my-2"
        }), _createElementVNode("div", _hoisted_1, [_createVNode(MonthlyCalendar, {
          date: season.value.currentDate.toDate(),
          min: season.value.startDate.toDate(),
          max: season.value.endDate.toDate()
        }, null, 8, ["date", "min", "max"])])]),
        _: 2
      }, [_ctx.$debug ? {
        name: "actionButton",
        fn: _withCtx(() => [_createVNode(_component_NButton, {
          text: "",
          onClick: _cache[0] || (_cache[0] = () => _ctx.$refs.simpleActionSheet.show())
        }, {
          default: _withCtx(() => [_createVNode(_component_Icon, {
            icon: _ctx.IconEnum.IosCog
          }, null, 8, ["icon"])]),
          _: 1
        }), _createVNode(SimpleActionSheet, {
          ref: "simpleActionSheet",
          "no-teleport": ""
        }, {
          actions: _withCtx(() => [_createVNode(SimpleActionSheetItem, {
            class: "italic",
            onClick: createNotification
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          }), _createVNode(SimpleActionSheetItem, {
            class: "italic",
            onClick: skipMonth
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('skip_one_month')), 1)]),
            _: 1
          }), _createVNode(SimpleActionSheetItem, {
            "hide-on-click": "",
            class: "italic",
            onClick: skipToEndOfSeason
          }, {
            default: _withCtx(() => [_hoisted_3]),
            _: 1
          })]),
          _: 1
        }, 512)])
      } : undefined]), 1024);
    };
  }
});